module.exports = __webpack_public_path__ + "img/20220219_072552.1bb5cc51.jpg";